import Vue from 'vue';
import VueRouter from 'vue-router';
import Service from '@/services/service';
import AndroidService from '@/services/android';
import Login from '@/views/Login';
import LoginPOS from '@/views/pos/Login';
import New from '@/views/New';
import NewPOS from '@/views/pos/New';
import SignDigitalContract from '@/views/SignDigitalContract';
import NewSuccess from '@/views/NewSuccess';
import Checkout from '@/views/Checkout';
import ContractAction from '@/views/ContractAction';
import AcceptTerms from '@/views/AcceptTerms';
import NotFound from '@/views/NotFound';

Vue.use(VueRouter);

const canAccessPOS = (query = {}) => {
  const hasPOSParam = query.pos === 'true';
  const isWebView = /webview|android.*appclient/i.test(navigator.userAgent);
  return hasPOSParam || isWebView;
};

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
    meta: {
      title: 'Entrar',
      requiresAuth: false,
    },
  },
  {
    path: '/pos/',
    name: 'loginPOS',
    component: LoginPOS,
    meta: {
      title: 'Entrar',
      requiresAuth: false,
      isPOS: true,
    },
  },
  {
    path: '/pos/logout',
    name: 'logoutPOS',
    component: LoginPOS,
    meta: {
      title: 'Desconectar',
      requiresAuth: false,
      isPOS: true,
      logout: true,
    },
  },
  {
    path: '/pos/precontract/new',
    name: 'newPOS',
    component: NewPOS,
    meta: {
      title: 'Novo contrato',
      requiresAuth: true,
      isPOS: true,
    },
  },
  {
    path: '/precontract/new',
    name: 'new',
    component: New,
    meta: {
      title: 'Novo contrato',
      requiresAuth: true,
    },
  },
  {
    path: '/precontract/success',
    name: 'newSuccess',
    component: NewSuccess,
    meta: {
      title: 'Sucesso',
      requiresAuth: true,
    },
  },
  {
    path: '/precontract/:contractId/contract/sign',
    name: 'signDigitalContract',
    component: SignDigitalContract,
    meta: {
      title: 'Assinar contrato',
      requiresAuth: false,
    },
  },
  {
    path: '/precontract/:contractId/checkout/pay',
    name: 'checkout',
    component: Checkout,
    meta: {
      title: 'Pagar pré-contrato',
      requiresAuth: false,
    },
  },
  {
    path: '/precontract/:contractId',
    name: 'contract',
    component: ContractAction,
    meta: {
      title: 'Detalhes do pré-contrato',
      requiresAuth: false,
    },
  },
  {
    path: '/precontract/:contractId/accept/terms',
    name: 'acceptTerms',
    component: AcceptTerms,
    meta: {
      title: 'Termos e condições de uso',
      requiresAuth: false,
    },
  },
  {
    path: '*',
    name: 'notFound',
    component: NotFound,
    meta: {
      title: 'Página não encontrada',
      requiresAuth: false,
    },
  },
];

const base = Service.getPlatformPrefix();
const router = new VueRouter({
  mode: 'history',
  base: base,
  routes,
});

router.beforeEach((to, from, next) => {
  const hasToken = !!localStorage.getItem('token');
  const isExternalAuth = to.query.token;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isPOSRoute = to.matched.some((record) => record.meta.isPOS);
  const isLogoutRoute = to.matched.some((record) => record.meta.logout);

  const platformName = Service.getPlatformName();
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} | ${platformName}`;
  }

  // Emitir evento de navegação para rotas POS
  if (isPOSRoute && canAccessPOS(to.query)) {
    try {
      const navigationEvent = {
        routeName: to.name,
        path: to.path,
        query: {
          darkMode: to.query.darkMode === 'true',
          pos: to.query.pos === 'true',
        },
      };

      AndroidService.sendMessage('im-route-changed', navigationEvent);
    } catch (error) {
      // Falha silenciosa em evento de telemetria
    }
  }

  if (isLogoutRoute) {
    localStorage.removeItem('token');
    next({
      name: 'loginPOS',
      query: {
        ...to.query,
        pos: 'true',
      },
    });
    return;
  }

  if (isPOSRoute && !canAccessPOS(to.query)) {
    if (to.name === 'loginPOS') {
      next({
        path: to.path,
        query: {
          ...to.query,
          pos: 'true',
        },
      });
      return;
    }

    if (hasToken) {
      next('/precontract/new');
    } else {
      next({
        name: 'loginPOS',
        query: {
          ...to.query,
          pos: 'true',
        },
      });
    }
    return;
  }

  if (hasToken && to.name === 'loginPOS') {
    next('/pos/precontract/new');
    return;
  }

  if (requiresAuth && !hasToken && to.name === 'new') {
    next('/');
    return;
  }

  if (requiresAuth && !hasToken && isPOSRoute) {
    next({
      name: 'loginPOS',
      query: to.query,
    });
    return;
  }
  if (requiresAuth && !hasToken && from.name !== 'login') {
    next('/');
    return;
  }

  if (hasToken && to.name == 'login' && !isExternalAuth) {
    next('/precontract/new');
    return;
  }

  next();
});

export default router;
